// extracted by mini-css-extract-plugin
module.exports = {"douPrice":"_18202","dou":"_4476","unit":"_332","extra":"_10346","prefix":"_18510"};